import {
  ToastContextWrapper,
  useToastContext,
  type ToastRecord,
  type ToastType,
} from "../containers/ToastContextWrapper";

export type { ToastType, ToastRecord };

export const ToastProvider = ToastContextWrapper;

export function useToast() {
  return useToastContext();
}

